import React, { useState } from "react";
import { Segment } from "semantic-ui-react";
import { SearchAddPage } from "./SearchAddPage";

export const AddSupplyUnitWizard = ({
  supplyUnits,
  setSupplyUnits,
  setAddingSupplyUnit,
  product,
}) => {
  const [page] = useState(1);
  const [wizardSupplyUnits, setWizardSupplyUnits] = useState([]);

  const onSubmit = () => {
    setSupplyUnits((prev) => [...prev, ...wizardSupplyUnits]);
    setAddingSupplyUnit(false);
  };

  const renderPageContent = () => {
    switch (page) {
      case 1:
        return (
          <SearchAddPage
            onSubmit={onSubmit}
            masterSupplyUnits={supplyUnits}
            supplyUnits={wizardSupplyUnits}
            setSupplyUnits={setWizardSupplyUnits}
            product={product}
            onClose={() => setAddingSupplyUnit(false)}
          />
        );

      default:
        return null;
    }
  };

  return <Segment>{renderPageContent()}</Segment>;
};
